(function () {
  'use strict';

  angular.module('sempraWebapp').factory('DashboardTechnologyViewModel', dashboardTechnologyViewModelFactory);

  /** @ngInject */
  function dashboardTechnologyViewModelFactory (FacilityTileViewModel) {
    function DashboardTechnologyViewModel (devicesJson) {
      this.devices = [];

      if (devicesJson) {
        refresh.call(this, devicesJson);
      }
    }

    DashboardTechnologyViewModel.prototype.destroy = function () {
      this.devices.forEach(function (facilityTileViewModel) {
        facilityTileViewModel.destroy();
      });
    };

    DashboardTechnologyViewModel.prototype.refreshTileDevice = function (newDeviceDataJson) {
      var tileViewModel = this.devices.find(function (deviceTileViewModel) {
        return newDeviceDataJson.path.indexOf(deviceTileViewModel.deviceSerial) > -1;
      });

      if (tileViewModel) {
        tileViewModel.refreshDevice(newDeviceDataJson);
      }
    };

    DashboardTechnologyViewModel.prototype.refreshTileDeviceFeed = function (newDeviceFeedJson) {
      var tileViewModel = this.devices.find(function (deviceTileViewModel) {
        return newDeviceFeedJson.path.indexOf(deviceTileViewModel.deviceSerial) > -1;
      });

      if (tileViewModel) {
        tileViewModel.refreshDeviceFeed(newDeviceFeedJson.data);
      }
    };

    DashboardTechnologyViewModel.prototype.refreshAlarms = function () {
      if (this.devices && this.devices.length > 0) {
        this.devices.forEach(function (tileVieWModel) {
          tileVieWModel.refreshAlarms();
        });
      }
    };

    return DashboardTechnologyViewModel;

    function refresh (devicesJson) {
      if (devicesJson) {
        devicesJson.forEach(function (deviceJson) {
          this.push(new FacilityTileViewModel(deviceJson));
        }, this.devices);
      }
    }
  }
})();
